export const MAIL_TO_PROYUGA_LINK =
  'mailto:info@proyuga.tech?subject=ProYuga Reach Us%20||%20Query&body=Your%20query'
